import Icon from "hardcover-ui/components/Icon";
import { IconThemeProps } from "hardcover-ui/theme/components/icon";
import ReadingFormatType, {
  ReadingFormatByID,
  ReadingFormatIDType,
} from "types/ReadingFormatType";

type Props = {
  readingFormatId: number | ReadingFormatIDType;
  className?: string;
  iconType?: "solid" | "regular";
  size?: IconThemeProps["size"];
};

export default function ReadingFormatIcon({
  readingFormatId = 1,
  className = "",
  iconType = "solid",
  size = "md",
}: Readonly<Props>) {
  const format: ReadingFormatType = ReadingFormatByID[readingFormatId];
  if (format) {
    return (
      <Icon
        icon={iconType === "solid" ? format.icon : format.iconRegular}
        aria-label={`${format.format} Icon`}
        className={className}
        size={size}
      />
    );
  }
  return <></>;
}
